export const StyledDropZone = {
  display: "flex",
  width: "100%"
};

export const StyledForbid = {
  cursor: "no-drop"
};
